// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-medias-page {
  --sm-navy: #0c2d5a;
  --sm-muted: #6b7c93;
  --sm-card: #ffffff;
  --sm-shadow: 0 2px 8px rgba(6, 52, 100, 0.08), 0 1px 3px rgba(6, 52, 100, 0.04);
  --sm-shadow-hover: 0 8px 24px rgba(6, 52, 100, 0.12), 0 2px 6px rgba(6, 52, 100, 0.06);
  --sm-cols: 3;
  --sm-gap: clamp(0.65rem, 2vw, 1rem);
  --sm-pad-x: clamp(1rem, 4vw, 2.5rem);
  --sm-pad-y: clamp(1.25rem, 3vh, 2.5rem);
  --sm-header-mb: clamp(1rem, 2.5vh, 1.75rem);
  --sm-logo: clamp(7.5rem, 18vw, 11rem);
  --sm-title: clamp(1.35rem, 2.5vw + 0.75rem, 2.1rem);
  --sm-subtitle: clamp(0.78rem, 1.2vw + 0.5rem, 0.95rem);
  --sm-card-pad: clamp(0.85rem, 2vw, 1.15rem);
  --sm-icon: clamp(2.25rem, 5vw, 2.75rem);
  --sm-name: clamp(0.82rem, 1.2vw + 0.4rem, 1rem);
  --sm-handle: clamp(0.7rem, 0.9vw + 0.35rem, 0.82rem);

  position: relative;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
  background: linear-gradient(165deg, #dce9fa 0%, #eef3fb 48%, #f7f9fc 100%);
  font-family: 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  color: var(--sm-navy);
}

.social-medias-page *,
.social-medias-page *::before,
.social-medias-page *::after {
  box-sizing: border-box;
}

.social-medias-page__inner {
  width: 100%;
  max-width: 72rem;
  margin: 0 auto;
  padding: var(--sm-pad-y) var(--sm-pad-x) clamp(2rem, 4vh, 3rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100%;
}

.social-medias-page__header {
  text-align: center;
  margin: 0 0 var(--sm-header-mb);
  width: 100%;
  max-width: 48rem;
  flex-shrink: 0;
}

.social-medias-page__logo {
  width: var(--sm-logo);
  height: auto;
  margin: 0 auto clamp(0.5rem, 1.5vh, 1rem);
  display: block;
}

.social-medias-page__title {
  margin: 0 0 0.45rem;
  font-size: var(--sm-title);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--sm-navy);
  line-height: 1.2;
}

.social-medias-page__subtitle {
  margin: 0 auto;
  font-size: var(--sm-subtitle);
  line-height: 1.5;
  color: var(--sm-muted);
  font-weight: 400;
  white-space: nowrap;
}

.social-medias-page__grid {
  display: grid;
  grid-template-columns: repeat(var(--sm-cols), minmax(0, 1fr));
  gap: var(--sm-gap);
  width: 100%;
  align-items: stretch;
  margin-bottom: clamp(1.25rem, 3vh, 2rem);
}

.social-medias-card {
  background: var(--sm-card);
  border-radius: 16px;
  box-shadow: var(--sm-shadow);
  padding: var(--sm-card-pad);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  color: inherit;
  border: 1px solid rgba(6, 52, 100, 0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  min-width: 0;
  width: 100%;
}

.social-medias-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--sm-shadow-hover);
  border-color: rgba(6, 52, 100, 0.1);
}

.social-medias-card:focus-visible {
  outline: 2px solid #0a57a8;
  outline-offset: 3px;
}

.social-medias-card__icon {
  width: var(--sm-icon);
  height: var(--sm-icon);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.55rem;
  flex-shrink: 0;
  box-shadow: 0 0 0 4px color-mix(in srgb, var(--icon-glow) 12%, transparent),
    0 0 12px color-mix(in srgb, var(--icon-glow) 24%, transparent);
}

.social-medias-card__icon svg {
  width: 48%;
  height: 48%;
  display: block;
  color: #fff;
}

.social-medias-card__text {
  min-width: 0;
}

.social-medias-card__name {
  margin: 0 0 0.15rem;
  font-size: var(--sm-name);
  font-weight: 700;
  color: var(--sm-navy);
  letter-spacing: -0.01em;
  line-height: 1.25;
}

.social-medias-card__handle {
  margin: 0;
  font-size: var(--sm-handle);
  color: var(--sm-muted);
  font-weight: 400;
  line-height: 1.3;
  word-break: break-word;
}

/* Share Your Experience */
.share-experience {
  width: 100%;
  background: var(--sm-card);
  border-radius: 16px;
  box-shadow: var(--sm-shadow);
  border: 1px solid rgba(6, 52, 100, 0.04);
  padding: clamp(1.15rem, 2.5vw, 1.75rem);
}

.share-experience__header {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  margin-bottom: clamp(1rem, 2vh, 1.35rem);
}

.share-experience__badge {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background: #0a57a8;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.share-experience__badge svg {
  width: 1.1rem;
  height: 1.1rem;
}

.share-experience__title {
  margin: 0 0 0.4rem;
  font-size: clamp(1.1rem, 1.5vw + 0.6rem, 1.35rem);
  font-weight: 700;
  color: var(--sm-navy);
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.share-experience__intro {
  margin: 0;
  font-size: clamp(0.8rem, 0.8vw + 0.55rem, 0.92rem);
  line-height: 1.55;
  color: var(--sm-muted);
}

.share-experience__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.9rem;
}

.share-message-card {
  --share-accent: #0a57a8;
  background: #fff;
  border: 1px solid rgba(6, 52, 100, 0.06);
  border-left: 4px solid var(--share-accent);
  border-radius: 14px;
  padding: 1rem 1rem 1.05rem;
  display: flex;
  flex-direction: column;
  min-width: 0;
  box-shadow: 0 1px 4px rgba(6, 52, 100, 0.04);
}

.share-message-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.share-message-card__label {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--share-accent);
}

.share-message-card__label-icon {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
}

.share-message-card__copy {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.7rem;
  border-radius: 8px;
  border: 1.5px solid var(--share-accent);
  background: #fff;
  color: var(--share-accent);
  font-size: 0.8rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.share-message-card__copy svg {
  width: 0.85rem;
  height: 0.85rem;
}

.share-message-card__copy:hover {
  background: var(--share-accent);
  color: #fff;
}

.share-message-card__copy:focus-visible {
  outline: 2px solid var(--share-accent);
  outline-offset: 2px;
}

.share-message-card__body {
  margin: 0 0 0.85rem;
  font-size: 0.84rem;
  line-height: 1.55;
  color: #334155;
  white-space: pre-line;
  flex: 1 1;
}

.share-message-card__hashtags {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.45;
  font-weight: 600;
  color: var(--share-accent);
  word-break: break-word;
}

@supports not (background: color-mix(in srgb, red 50%, white)) {
  .social-medias-card__icon {
    box-shadow: 0 0 12px rgba(10, 87, 168, 0.18);
  }
}

/* Tablet / small desktop: 3 × 2 social + 3 share columns when wide enough */
@media (min-width: 768px) {
  .social-medias-page {
    --sm-cols: 3;
    --sm-logo: clamp(8.5rem, 14vw, 11rem);
  }

  .share-experience__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: stretch;
  }
}

/* Desktop: 6 social cards in one row (icon left, text right) */
@media (min-width: 1200px) {
  .social-medias-page {
    --sm-cols: 6;
    --sm-gap: clamp(0.7rem, 1vw, 1rem);
    --sm-logo: clamp(9rem, 12vh, 12rem);
    --sm-card-pad: 0.9rem 1rem;
    --sm-icon: 2.5rem;
    --sm-name: 0.9rem;
    --sm-handle: 0.75rem;
  }

  .social-medias-page__inner {
    max-width: min(78rem, 96vw);
  }

  .social-medias-card {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    gap: 0.75rem;
  }

  .social-medias-card__icon {
    margin-bottom: 0;
  }
}

/* Mobile: 3 × 2 social grid, stacked share cards */
@media (max-width: 767px) {
  .social-medias-page {
    --sm-cols: 3;
    --sm-pad-y: clamp(0.85rem, 2vh, 1.25rem);
    --sm-header-mb: clamp(0.75rem, 2vh, 1.1rem);
    --sm-logo: clamp(6.5rem, 22vw, 9rem);
    --sm-title: clamp(1.2rem, 5vw, 1.5rem);
    --sm-subtitle: clamp(0.72rem, 3vw, 0.85rem);
    --sm-gap: clamp(0.5rem, 2vw, 0.7rem);
    --sm-card-pad: 0.75rem 0.5rem;
    --sm-icon: clamp(1.9rem, 7vw, 2.35rem);
    --sm-name: clamp(0.7rem, 2.8vw, 0.82rem);
    --sm-handle: clamp(0.6rem, 2.2vw, 0.7rem);
  }

  .social-medias-page__inner {
    max-width: 100%;
    padding-bottom: 2rem;
  }

  .social-medias-page__header {
    max-width: 22rem;
  }

  .social-medias-page__subtitle {
    white-space: normal;
  }

  .social-medias-card__icon {
    margin-bottom: 0.4rem;
  }

  .share-experience__header {
    gap: 0.7rem;
  }

  .share-experience__badge {
    width: 2.15rem;
    height: 2.15rem;
  }

  .share-experience__grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 420px) {
  .social-medias-page {
    --sm-pad-x: 0.75rem;
    --sm-cols: 2;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/social-medias/social-medias.page.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,+EAA+E;EAC/E,sFAAsF;EACtF,YAAY;EACZ,mCAAmC;EACnC,oCAAoC;EACpC,uCAAuC;EACvC,2CAA2C;EAC3C,qCAAqC;EACrC,mDAAmD;EACnD,sDAAsD;EACtD,2CAA2C;EAC3C,uCAAuC;EACvC,+CAA+C;EAC/C,oDAAoD;;EAEpD,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,0EAA0E;EAC1E,gEAAgE;EAChE,qBAAqB;AACvB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,+DAA+D;EAC/D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,wCAAwC;EACxC,6EAA6E;EAC7E,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd;kEACgE;AAClE;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,4BAA4B;EAC5B,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kDAAkD;EAClD,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,wCAAwC;EACxC,0CAA0C;EAC1C,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,yDAAyD;AAC3D;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,SAAO;AACT;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA,4EAA4E;AAC5E;EACE;IACE,YAAY;IACZ,qCAAqC;EACvC;;EAEA;IACE,gDAAgD;IAChD,oBAAoB;EACtB;AACF;;AAEA,+DAA+D;AAC/D;EACE;IACE,YAAY;IACZ,kCAAkC;IAClC,mCAAmC;IACnC,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,YAAY;IACZ,wCAAwC;IACxC,2CAA2C;IAC3C,oCAAoC;IACpC,sCAAsC;IACtC,2CAA2C;IAC3C,oCAAoC;IACpC,6BAA6B;IAC7B,sCAAsC;IACtC,wCAAwC;IACxC,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;AACF","sourcesContent":[".social-medias-page {\n  --sm-navy: #0c2d5a;\n  --sm-muted: #6b7c93;\n  --sm-card: #ffffff;\n  --sm-shadow: 0 2px 8px rgba(6, 52, 100, 0.08), 0 1px 3px rgba(6, 52, 100, 0.04);\n  --sm-shadow-hover: 0 8px 24px rgba(6, 52, 100, 0.12), 0 2px 6px rgba(6, 52, 100, 0.06);\n  --sm-cols: 3;\n  --sm-gap: clamp(0.65rem, 2vw, 1rem);\n  --sm-pad-x: clamp(1rem, 4vw, 2.5rem);\n  --sm-pad-y: clamp(1.25rem, 3vh, 2.5rem);\n  --sm-header-mb: clamp(1rem, 2.5vh, 1.75rem);\n  --sm-logo: clamp(7.5rem, 18vw, 11rem);\n  --sm-title: clamp(1.35rem, 2.5vw + 0.75rem, 2.1rem);\n  --sm-subtitle: clamp(0.78rem, 1.2vw + 0.5rem, 0.95rem);\n  --sm-card-pad: clamp(0.85rem, 2vw, 1.15rem);\n  --sm-icon: clamp(2.25rem, 5vw, 2.75rem);\n  --sm-name: clamp(0.82rem, 1.2vw + 0.4rem, 1rem);\n  --sm-handle: clamp(0.7rem, 0.9vw + 0.35rem, 0.82rem);\n\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  height: 100dvh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior-y: contain;\n  background: linear-gradient(165deg, #dce9fa 0%, #eef3fb 48%, #f7f9fc 100%);\n  font-family: 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  color: var(--sm-navy);\n}\n\n.social-medias-page *,\n.social-medias-page *::before,\n.social-medias-page *::after {\n  box-sizing: border-box;\n}\n\n.social-medias-page__inner {\n  width: 100%;\n  max-width: 72rem;\n  margin: 0 auto;\n  padding: var(--sm-pad-y) var(--sm-pad-x) clamp(2rem, 4vh, 3rem);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 100%;\n}\n\n.social-medias-page__header {\n  text-align: center;\n  margin: 0 0 var(--sm-header-mb);\n  width: 100%;\n  max-width: 48rem;\n  flex-shrink: 0;\n}\n\n.social-medias-page__logo {\n  width: var(--sm-logo);\n  height: auto;\n  margin: 0 auto clamp(0.5rem, 1.5vh, 1rem);\n  display: block;\n}\n\n.social-medias-page__title {\n  margin: 0 0 0.45rem;\n  font-size: var(--sm-title);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--sm-navy);\n  line-height: 1.2;\n}\n\n.social-medias-page__subtitle {\n  margin: 0 auto;\n  font-size: var(--sm-subtitle);\n  line-height: 1.5;\n  color: var(--sm-muted);\n  font-weight: 400;\n  white-space: nowrap;\n}\n\n.social-medias-page__grid {\n  display: grid;\n  grid-template-columns: repeat(var(--sm-cols), minmax(0, 1fr));\n  gap: var(--sm-gap);\n  width: 100%;\n  align-items: stretch;\n  margin-bottom: clamp(1.25rem, 3vh, 2rem);\n}\n\n.social-medias-card {\n  background: var(--sm-card);\n  border-radius: 16px;\n  box-shadow: var(--sm-shadow);\n  padding: var(--sm-card-pad);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  text-decoration: none;\n  color: inherit;\n  border: 1px solid rgba(6, 52, 100, 0.04);\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  min-width: 0;\n  width: 100%;\n}\n\n.social-medias-card:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--sm-shadow-hover);\n  border-color: rgba(6, 52, 100, 0.1);\n}\n\n.social-medias-card:focus-visible {\n  outline: 2px solid #0a57a8;\n  outline-offset: 3px;\n}\n\n.social-medias-card__icon {\n  width: var(--sm-icon);\n  height: var(--sm-icon);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.55rem;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 4px color-mix(in srgb, var(--icon-glow) 12%, transparent),\n    0 0 12px color-mix(in srgb, var(--icon-glow) 24%, transparent);\n}\n\n.social-medias-card__icon svg {\n  width: 48%;\n  height: 48%;\n  display: block;\n  color: #fff;\n}\n\n.social-medias-card__text {\n  min-width: 0;\n}\n\n.social-medias-card__name {\n  margin: 0 0 0.15rem;\n  font-size: var(--sm-name);\n  font-weight: 700;\n  color: var(--sm-navy);\n  letter-spacing: -0.01em;\n  line-height: 1.25;\n}\n\n.social-medias-card__handle {\n  margin: 0;\n  font-size: var(--sm-handle);\n  color: var(--sm-muted);\n  font-weight: 400;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n/* Share Your Experience */\n.share-experience {\n  width: 100%;\n  background: var(--sm-card);\n  border-radius: 16px;\n  box-shadow: var(--sm-shadow);\n  border: 1px solid rgba(6, 52, 100, 0.04);\n  padding: clamp(1.15rem, 2.5vw, 1.75rem);\n}\n\n.share-experience__header {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n  margin-bottom: clamp(1rem, 2vh, 1.35rem);\n}\n\n.share-experience__badge {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  background: #0a57a8;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.share-experience__badge svg {\n  width: 1.1rem;\n  height: 1.1rem;\n}\n\n.share-experience__title {\n  margin: 0 0 0.4rem;\n  font-size: clamp(1.1rem, 1.5vw + 0.6rem, 1.35rem);\n  font-weight: 700;\n  color: var(--sm-navy);\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.share-experience__intro {\n  margin: 0;\n  font-size: clamp(0.8rem, 0.8vw + 0.55rem, 0.92rem);\n  line-height: 1.55;\n  color: var(--sm-muted);\n}\n\n.share-experience__grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.9rem;\n}\n\n.share-message-card {\n  --share-accent: #0a57a8;\n  background: #fff;\n  border: 1px solid rgba(6, 52, 100, 0.06);\n  border-left: 4px solid var(--share-accent);\n  border-radius: 14px;\n  padding: 1rem 1rem 1.05rem;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  box-shadow: 0 1px 4px rgba(6, 52, 100, 0.04);\n}\n\n.share-message-card__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.share-message-card__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--share-accent);\n}\n\n.share-message-card__label-icon {\n  width: 1rem;\n  height: 1rem;\n  flex-shrink: 0;\n}\n\n.share-message-card__copy {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.35rem 0.7rem;\n  border-radius: 8px;\n  border: 1.5px solid var(--share-accent);\n  background: #fff;\n  color: var(--share-accent);\n  font-size: 0.8rem;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.share-message-card__copy svg {\n  width: 0.85rem;\n  height: 0.85rem;\n}\n\n.share-message-card__copy:hover {\n  background: var(--share-accent);\n  color: #fff;\n}\n\n.share-message-card__copy:focus-visible {\n  outline: 2px solid var(--share-accent);\n  outline-offset: 2px;\n}\n\n.share-message-card__body {\n  margin: 0 0 0.85rem;\n  font-size: 0.84rem;\n  line-height: 1.55;\n  color: #334155;\n  white-space: pre-line;\n  flex: 1;\n}\n\n.share-message-card__hashtags {\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 1.45;\n  font-weight: 600;\n  color: var(--share-accent);\n  word-break: break-word;\n}\n\n@supports not (background: color-mix(in srgb, red 50%, white)) {\n  .social-medias-card__icon {\n    box-shadow: 0 0 12px rgba(10, 87, 168, 0.18);\n  }\n}\n\n/* Tablet / small desktop: 3 × 2 social + 3 share columns when wide enough */\n@media (min-width: 768px) {\n  .social-medias-page {\n    --sm-cols: 3;\n    --sm-logo: clamp(8.5rem, 14vw, 11rem);\n  }\n\n  .share-experience__grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    align-items: stretch;\n  }\n}\n\n/* Desktop: 6 social cards in one row (icon left, text right) */\n@media (min-width: 1200px) {\n  .social-medias-page {\n    --sm-cols: 6;\n    --sm-gap: clamp(0.7rem, 1vw, 1rem);\n    --sm-logo: clamp(9rem, 12vh, 12rem);\n    --sm-card-pad: 0.9rem 1rem;\n    --sm-icon: 2.5rem;\n    --sm-name: 0.9rem;\n    --sm-handle: 0.75rem;\n  }\n\n  .social-medias-page__inner {\n    max-width: min(78rem, 96vw);\n  }\n\n  .social-medias-card {\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    text-align: left;\n    gap: 0.75rem;\n  }\n\n  .social-medias-card__icon {\n    margin-bottom: 0;\n  }\n}\n\n/* Mobile: 3 × 2 social grid, stacked share cards */\n@media (max-width: 767px) {\n  .social-medias-page {\n    --sm-cols: 3;\n    --sm-pad-y: clamp(0.85rem, 2vh, 1.25rem);\n    --sm-header-mb: clamp(0.75rem, 2vh, 1.1rem);\n    --sm-logo: clamp(6.5rem, 22vw, 9rem);\n    --sm-title: clamp(1.2rem, 5vw, 1.5rem);\n    --sm-subtitle: clamp(0.72rem, 3vw, 0.85rem);\n    --sm-gap: clamp(0.5rem, 2vw, 0.7rem);\n    --sm-card-pad: 0.75rem 0.5rem;\n    --sm-icon: clamp(1.9rem, 7vw, 2.35rem);\n    --sm-name: clamp(0.7rem, 2.8vw, 0.82rem);\n    --sm-handle: clamp(0.6rem, 2.2vw, 0.7rem);\n  }\n\n  .social-medias-page__inner {\n    max-width: 100%;\n    padding-bottom: 2rem;\n  }\n\n  .social-medias-page__header {\n    max-width: 22rem;\n  }\n\n  .social-medias-page__subtitle {\n    white-space: normal;\n  }\n\n  .social-medias-card__icon {\n    margin-bottom: 0.4rem;\n  }\n\n  .share-experience__header {\n    gap: 0.7rem;\n  }\n\n  .share-experience__badge {\n    width: 2.15rem;\n    height: 2.15rem;\n  }\n\n  .share-experience__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 420px) {\n  .social-medias-page {\n    --sm-pad-x: 0.75rem;\n    --sm-cols: 2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
